import { styled } from 'goober';
import { PrimaryButton } from './Button';
export var SelectContainer = styled('div')(function () { return ({
    position: 'relative',
}); });
export var SelectBtnTrigger = styled(PrimaryButton)(function () { return ({
    width: 'auto',
}); });
export var SelectOptions = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        position: 'absolute',
        top: 'calc(100% + 10px)',
        backgroundColor: '#fff',
        border: "1px solid ".concat(theme.borderColor),
        boxShadow: 'rgb(107 131 160 / 15%) 0px 4px 16px',
        right: 0,
        zIndex: 1,
    });
});
export var SelectOption = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        padding: '5px 10px',
        borderBottom: "1px solid ".concat(theme.borderColor),
        fontSize: '12px',
        lineHeight: '22px',
        cursor: 'pointer',
        '&:last-child': {
            borderBottom: 'none',
        },
        '&:hover': {
            backgroundColor: theme.colors.neutral.w100,
        },
    });
});
